import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { KeyboardShortcutsInfoButton } from "~/components/AssetModal/Panel/Tabs/KeyboardShortcutsInfoButton/KeyboardShortcutsInfoButton";
export const Tabs = /*#__PURE__*/ memo((param)=>{
    let { children, className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("flex h-full flex-col items-center justify-between border-l border-l-grey-5 bg-grey-1", className),
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-full w-[72px] min-w-[72px] flex-col items-center justify-start overflow-y-auto pt-[30px]",
                children: children
            }),
            /*#__PURE__*/ _jsx(KeyboardShortcutsInfoButton, {})
        ]
    });
});
Tabs.displayName = "Tabs";
